import { ThemeOptions } from '@mui/material/styles'

export const adminSpacing: Required<Pick<ThemeOptions, 'spacing'>> = {
  spacing: 4
}
